import { useEffect, useState } from 'react';

/**
 * `true` a partir de 768px (el breakpoint `md` de Tailwind): el ancho desde el cual la
 * app monta el shell nuevo con su sidebar en flujo —
 * ADR-2026-08-05-el-shell-nuevo-arranca-en-768.
 *
 * Existe aparte de `useIsDesktop` (1024px) porque son dos preguntas distintas. Aquél
 * pregunta "¿es una pantalla grande?" y lo usan el alta y el catálogo de planes para
 * decidir su layout. Éste pregunta "¿va la sidebar o va la barra inferior?", y esa
 * frontera es la misma que la del `<aside>` de la app (`hidden md:flex`): abajo de 768
 * no entra una sidebar al costado, arriba sí.
 *
 * Mientras las dos preguntas compartieron hook, la franja de 768 a 1023 se quedaba con
 * el chrome viejo —sidebar antigua incluida— aunque el contenido ya fuera el nuevo.
 *
 * Reactivo: se actualiza al cruzar el breakpoint (resize / rotación).
 */
const QUERY = '(min-width: 768px)';

export function useShellEscritorio(): boolean {
  const [esEscritorio, setEsEscritorio] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setEsEscritorio(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return esEscritorio;
}

export default useShellEscritorio;
